const setToken = token => {
  return window.sessionStorage.setItem("tokenStr", token);
};

const getToken = () => {
  return window.sessionStorage.getItem("tokenStr");
};

const removeToken = () => {
  return window.sessionStorage.removeItem("tokenStr");
};

export { setToken, getToken, removeToken };



// WEBPACK FOOTER //
// ./src/views/utils/authUtils.js